module.exports = __webpack_public_path__ + "img/fаlag-it.76f5303f.svg";